import { Box, IconButton, Menu, MenuItem } from '@material-ui/core'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { UseGetWeedDiagnosesResult } from '@/hooks/queries/use-get-weed-diagnoses'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

type EditDiagnosisMenuProps = {
  row: Pick<
    UseGetWeedDiagnosesResult,
    | 'id'
    | 'demandName'
    | 'project'
    | 'culture'
    | 'treatment'
    | 'flightDate'
    | 'imageType'
  >
  menuDisabled: boolean
}

export function EditDiagnosisMenu({
  row,
  menuDisabled,
}: EditDiagnosisMenuProps) {
  const classes = useStyles()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    anchorEl?.focus()
    setAnchorEl(null)
  }

  const handleEditClick = () => {
    navigate(routes.EditDiagnosis('editname', row.id), {
      state: {
        demandName: row.demandName,
        project: row.project,
        culture: row.culture,
        treatment: row.treatment,
        flightDate: row.flightDate,
        imageType: row.imageType,
      },
    })
    handleMenuClose()
  }

  return (
    <Box className={classes.menuIconWrapper}>
      <IconButton
        aria-label='Abrir menu'
        className={classes.menuIconButton}
        onClick={handleMenuOpen}
        disabled={menuDisabled}
      >
        <MoreVertIcon fontSize='small' />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        classes={{ paper: classes.menuPaper }}
        transformOrigin={{ vertical: -26, horizontal: 'right' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        elevation={2}
      >
        <MenuItem onClick={handleEditClick} className={classes.menuItem}>
          <EditOutlinedIcon fontSize='small' />
          Editar Diagnóstico
        </MenuItem>
      </Menu>
    </Box>
  )
}
